export default __webpack_public_path__ + "e27d06c655f20f32e0b36704fb11fb8f.png";